import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
} from '@material-ui/core';

import useStyles from './styles';
import {
    updateWidgetSettings,
    // updateWidgetSetting,
} from './widgetUtil';

/*
PROD: omPbJveLsO6YQ8gjUUy6y0awtjd5oL2GOLTEKTxtX862b16aa0 -> pub_id: 472501
STAGE: mpK0ncK3vIDgKn4wMCbJmSabiBZTUFpBgyl3eUp8p062a7dc6c -> pub_id: 14414
TEST: iO4vouUk2ZQ1FvdIKIrlZGdTSztVhkTcBhdRJkIxLX86242a0b
*/
const urlSource = {
    prod: 'https://sync.ecal.com/?apiKey=omPbJveLsO6YQ8gjUUy6y0awtjd5oL2GOLTEKTxtX862b16aa0&mode=preview',
    stage: 'https://staging-sync.ecal.com/?apiKey=mpK0ncK3vIDgKn4wMCbJmSabiBZTUFpBgyl3eUp8p062a7dc6c&mode=preview',
    test: 'https://testing-sync.ecal.com/?apiKey=iO4vouUk2ZQ1FvdIKIrlZGdTSztVhkTcBhdRJkIxLX86242a0b&mode=preview',
    local: 'https://testing-sync.ecal.com/?apiKey=iO4vouUk2ZQ1FvdIKIrlZGdTSztVhkTcBhdRJkIxLX86242a0b&mode=preview',
    // prod: 'https://localhost:2090/?&apiKey=iO4vouUk2ZQ1FvdIKIrlZGdTSztVhkTcBhdRJkIxLX86242a0b&mode=preview',
};

const defalutLogo = 'https://d27vx6ekipa712.cloudfront.net/assets/app/logo-round.svg';

function getWidgetURL () {
    const env = import.meta.env.VITE_ENV_VAR;
    if (env === 'prod') {
        return urlSource.prod;
    }
    if (env === 'stage') {
        return urlSource.stage;
    }

    if (env === 'dev') {
        return urlSource.test;
    }

    return urlSource.prod;
}

function WidgetPreview (props) {
    const {
        styleData,
    } = props;
    const classes = useStyles();

    const iframeRef = useRef();
    const [previewURL] = useState(getWidgetURL());

    function updateWidgetStyle () {
        // console.log('Style Data: ', styleData);

        const settings = {
            primary_button_background: styleData.secondaryColour,
            header_background: styleData.headingColour,
            logo: styleData.logo || defalutLogo,
            logo_shadow: styleData.logoShadow,
            logoShadow: styleData.logoShadow,
            logoShape: styleData.logoShape,
            logo_shape: styleData.logoShape || 'round',
        };

        if (styleData.cssFile) {
            settings.customCssUrl = styleData.cssFile;
        }

        if (styleData.bannerType) {
            settings.bannerType = styleData.bannerType;
            settings.bannerURL = styleData.bannerURL;
            settings.bannerColour = styleData.bannerColour;
            if (styleData.bannerType === 'image' && !styleData.bannerURL) {
                settings.bannerType = 'solid';
                settings.bannerColour = '#FFFFFF';
            }
        }

        if (!styleData.bannerType) {
            settings.bannerType = 'solid';
            settings.bannerColour = settings.primary_button_background;
        }

        if (styleData.logoTransparent) {
            settings.logoTransparent = styleData.logoTransparent;
        } else {
            settings.logoTransparent = false;
        }
        // console.log('AdminV4.widget.updateWidgetStyle(): ', settings);
        updateWidgetSettings(iframeRef.current.contentWindow, settings);
    }

    function updateLanguage () {
        const settings = {
            language: styleData.language,
        };
        updateWidgetSettings(iframeRef.current.contentWindow, settings);
    }

    useEffect(() => {
        // console.log('WidgetPreview.useEffect(): ', styleData);
        updateWidgetStyle();
    }, [styleData]);

    const widgetAppListener = (e) => {
        if (e.data.action === 'kickstartComplete') {
            updateWidgetStyle();
        }
    };

    useEffect(() => {
        window.addEventListener('message', widgetAppListener);
        return () => {
            window.removeEventListener('message', widgetAppListener);
        };
    }, []);

    useEffect(() => {
        updateLanguage();
    }, [styleData.language]);

    return (
        <Grid className={classes.fullSize}>
            <iframe
                onLoad={() => {
                    // eslint-disable-next-line no-undef
                    updateWidgetStyle();
                }}

                ref={iframeRef}
                className={classes.widgetPreviewMode}
                id="widget-demo"
                scrolling="no"
                frameBorder={0}
                src={previewURL}
            >
            </iframe>
        </Grid>
    );
}

WidgetPreview.propTypes = {
    styleData: PropTypes.any,
};

WidgetPreview.defaultProps = {
   styleData: {},
};

export default WidgetPreview;
